import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Tabs,
  Tab,
  Modal,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  allDate,
  allMonth,
  formLabelsTheme,
  iconError,
  paginationSet,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import {
  fetchGroupCountry,
  fetchGroupPhoneType,
  fetchParameter,
  fetchParameter2,
  selectCountry,
  selectParameter,
  selectParameter2,
  selectParameter3,
  selectPhoneType,
} from "../businessParameter/businessParameterSlice";
// MUI
import { makeStyles, fade, ThemeProvider } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import {
  FilledInput,
  FormControl,
  FormHelperText,
  InputLabel,
} from "@material-ui/core";
import SelectMUI from "@material-ui/core/Select";
import { Autocomplete } from "@material-ui/lab";
import {
  addClient,
  editClient,
  fetchClient,
  fetchIdClient,
  removeOfficeMapping,
  selectIdClient,
  selectLoading,
} from "./clientSlice";
import { ModalClient } from "../motorPool/ModalClient";
import { ModalOffice } from "../motorPool/ModalOffice";
import { fetchOffice } from "../office/officeSlice";
import { ModalOfficeSelect } from "../filterModal/ModalOfficeSelect";
import { fetchCountryAll, selectCountryAll } from "../location/locationSlice";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  focused: {},
}));

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const ClientEdit = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectIdClient);
  const dataPhoneType = useSelector(selectPhoneType);
  const dataCountry = useSelector(selectCountryAll);
  const { id } = useParams();

  // initial

  const [formValues, setFormValues] = useState({
    client_code: {
      value: "",
      error: false,
      required: "Y",
    },
    client_name: {
      value: "",
      error: false,
      required: "Y",
    },
    first_name: {
      value: "",
      error: false,
      required: "N",
    },
    last_name: {
      value: "",
      error: false,
      required: "N",
    },
    address1: {
      value: "",
      error: false,
      required: "Y",
    },
    address2: {
      value: "",
      error: false,
      required: "N",
    },

    city: {
      value: "",
      error: false,
      required: "N",
    },
    zipcode: {
      value: "",
      error: false,
      required: "N",
    },
    country_id: {
      value: "",
      error: false,
      required: "Y",
    },
    province: {
      value: "",
      error: false,
      required: "N",
    },
    email: {
      value: "",
      error: false,
      required: "N",
    },
  });

  const [fieldsCP, setFieldsCP] = useState([
    {
      phone_type: "",
      phone: "",
    },
  ]);

  const [listOffice, setListOffice] = useState([]);
  const [fields, setFields] = useState([
    { id: "", value: "", params: "", label: "", add: "N", editor: "text" },
  ]);

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      await dispatch(
        fetchCountryAll({
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(fetchIdClient(id));

      await dispatch(fetchGroupPhoneType("PHONETYPE"));
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataId !== null) {
      setFormValues({
        client_code: {
          value: dataId.client_code,
          error: false,
          required: "Y",
        },
        client_name: {
          value: dataId.client_name,
          error: false,
          required: "Y",
        },
        first_name: {
          value: dataId.first_name,
          error: false,
          required: "N",
        },
        last_name: {
          value: dataId.last_name,
          error: false,
          required: "N",
        },
        address1: {
          value: dataId.address1,
          error: false,
          required: "Y",
        },
        address2: {
          value: dataId.address2,
          error: false,
          required: "N",
        },

        city: {
          value: dataId.city,
          error: false,
          required: "N",
        },
        zipcode: {
          value: dataId.zipcode,
          error: false,
          required: "N",
        },
        country_id: {
          value: dataId.country_id,
          error: false,
          required: "Y",
        },
        province: {
          value: dataId.province,
          error: false,
          required: "N",
        },
        email: {
          value: dataId.email,
          error: false,
          required: "N",
        },
      });

      const initData =
        dataId.contactpersons === null
          ? fieldsCP
          : dataId.contactpersons.map((item, index) => {
              return {
                phone_type: item.phone_type,
                phone: item.phone,
              };
            });

      setFieldsCP(initData);
      setListOffice(dataId.clientOffices === null ? [] : dataId.clientOffices);
    }
  }, [dataId]);

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);
    return isValid;
  };

  const handleSave = async () => {
    if (!validatePost()) {
      return;
    }
    const params = {
      client_id: id,
      client_code: formValues.client_code.value,
      client_name: formValues.client_name.value,
      address1: formValues.address1.value,
      address2: formValues.address2.value,
      city: formValues.city.value,
      zipcode: formValues.zipcode.value,
      country_id: formValues.country_id.value,
      province: formValues.province.value,
      first_name: formValues.first_name.value,
      last_name: formValues.last_name.value,
      email: formValues.email.value,
      contactpersons: fieldsCP.map((item, index) => {
        return {
          phone_type: item.phone_type,
          phone: item.phone,
        };
      }),
      offices: listOffice,
    };

    try {
      const response = await dispatch(editClient(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdClient(id));
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  function handlePhoneChange(i, event) {
    const values = [...fieldsCP];
    values[i].phone = event.target.value;
    setFieldsCP(values);
  }

  function handleAdd() {
    const values = [...fieldsCP];
    values.push({
      phone_type: "",
      phone: "",
    });
    setFieldsCP(values);
    return true
  }

  function handleRemove(i) {
    const values = [...fieldsCP];
    values.splice(i, 1);
    setFieldsCP(values);
    return true
  }

  const handleTypeChange = (i, event) => {
    const values = [...fieldsCP];
    values[i].phone_type = event.value;
    setFieldsCP(values);
    return true
  };

  const getValueType = (value, options) => {
    const return_value = options.filter((val) => value === val.value);
    return return_value;
  };

  const typePhone = dataPhoneType.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const countryOptions = dataCountry.map((e) => {
    return {
      value: e.country_id,
      label: e.country_name,
    };
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };
  const handleChangeCountry = (e, country) => {
    const value = country.value;
    setFormValues({
      ...formValues,
      ["country_id"]: {
        ...formValues["country_id"],
        value,
      },
    });
  };

  const index = countryOptions.findIndex(
    (obj) => obj.value === formValues.country_id.value
  );

  // modal office

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    dispatch(
      fetchOffice({
        is_enable: "Y",
        pageNo: 1,
        pageSize: paginationSet,
      })
    );
    setShow(true);
  };

  const handleDelete = async (e, row) => {
    console.log(row, "row");
    const params = {
      office_id: row.office_id,
      clientoffices_id: row.clientoffices_id,
    };
    const action = await showDeleteDialog(`Are you sure you want to delete?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(removeOfficeMapping({ data: params }));
        if (response.payload.data.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await dispatch(fetchIdClient(id));
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const actionFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
        >
          <div
            className="btn btn-icon btn-primary btn-hover-primary btn-sm"
            onClick={(e) => handleDelete(e, row)}
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")} />
            </span>
          </div>
        </OverlayTrigger>
      </div>
    );
  };

  const columns = [
    {
      text: "Office Code",
      dataField: "office_code",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Office Name",
      dataField: "office_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "City",
      dataField: "city",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Province",
      dataField: "province",
      headerAlign: "center",
    },
    {
      text: "Country",
      dataField: "country_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatter,
      align: "center",
      headerAlign: "center",
      formatExtraData: listOffice,
    },
  ];
  return loading ? (
    <LayoutSplashScreen />
  ) : (
    dataId && (
      <>
        <Card>
          <CardHeader>
            <CardHeaderTitle className="card-title text-white ">
              Client : {dataId.client_name}
            </CardHeaderTitle>
            <CardHeaderToolbar>
              <Button className="primary" onClick={() => history.goBack()}>
                Back To List
              </Button>
            </CardHeaderToolbar>
          </CardHeader>
          <ThemeProvider theme={formLabelsTheme}>
            <CardBody>
              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    required
                    label="Code"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="client_code"
                    value={formValues.client_code.value}
                    onChange={handleChange}
                    error={formValues.client_code.error}
                    helperText={
                      formValues.client_code.error ? (
                        <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                          {iconError} {"This field is required"}
                        </FormHelperText>
                      ) : (
                        ""
                      )
                    }
                  />

                  <RedditTextField
                    required
                    label="Address Line 1"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    multiline
                    rows="4"
                    name="address1"
                    value={formValues.address1.value}
                    onChange={handleChange}
                    error={formValues.address1.error}
                    helperText={
                      formValues.address1.error ? (
                        <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                          {iconError} {"This field is required"}
                        </FormHelperText>
                      ) : (
                        ""
                      )
                    }
                  />
                  <RedditTextField
                    label="City"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="city"
                    onChange={handleChange}
                    value={formValues.city.value}
                  />
                  <RedditTextField
                    label="Province"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="province"
                    onChange={handleChange}
                    value={formValues.province.value}
                  />
                </Col>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    required
                    label="Name"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="client_name"
                    value={formValues.client_name.value}
                    onChange={handleChange}
                    error={formValues.client_name.error}
                    helperText={
                      formValues.client_name.error ? (
                        <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                          {iconError} {"This field is required"}
                        </FormHelperText>
                      ) : (
                        ""
                      )
                    }
                  />
                  <RedditTextField
                    label="Address Line 2"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    multiline
                    rows="4"
                    name="address2"
                    onChange={handleChange}
                    value={formValues.address2.value}
                  />
                  <RedditTextField
                    label="Zipcode"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="zipcode"
                    onChange={handleChange}
                    value={formValues.zipcode.value}
                  />
                  <Autocomplete
                    disablePortal
                    name="country_id"
                    options={countryOptions}
                    getOptionLabel={(option) => option.label}
                    getOptionValue={(option) => option.value}
                    disableClearable={true}
                    onChange={handleChangeCountry}
                    value={
                      countryOptions.find(
                        (option) => option.value === formValues.country_id.value
                      ) || null
                    }
                    renderInput={(params) => (
                      <RedditTextField
                        required
                        className={classes.margin}
                        {...params}
                        label="Country"
                        id="reddit-input"
                        size="small"
                        fullWidth
                        placeholder="Select Country"
                        name="country_id"
                      />
                    )}
                  />
                </Col>
              </Row>
              <p className="font-weight-bold  m-3">Contact Person :</p>

              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    label="First Name"
                    inputProps={{ maxLength: 128 }}
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="first_name"
                    onChange={handleChange}
                    value={formValues.first_name.value}
                  />
                </Col>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    label="Last Name"
                    inputProps={{ maxLength: 128 }}
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="last_name"
                    onChange={handleChange}
                    value={formValues.last_name.value}
                  />
                </Col>
              </Row>

              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  {fieldsCP.map((field, idx) => {
                    return (
                      <div key={`${field}-${idx}`}>
                        <Row>
                          <Col md={4}>
                            <Select
                              // isClearable={true}
                              options={typePhone}
                              value={getValueType(field.phone_type, typePhone)}
                              placeholder="Type"
                              onChange={(e) => handleTypeChange(idx, e)}
                              className="mt-4 ml-3"
                            />
                          </Col>
                          <Col md={6}>
                            <RedditTextField
                              label="Phone Number"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              size="small"
                              type="number"
                              fullWidth
                              value={field.phone || ""}
                              onChange={(e) => handlePhoneChange(idx, e)}
                            />
                          </Col>
                          {fieldsCP.length !== 1 && (
                            <Col>
                              <div
                                className="btn btn-iconError btn-primary btn-hover-primary btn-sm mt-4 "
                                onClick={() => handleRemove(idx)}
                              >
                                <span className="svg-iconError svg-iconError-md svg-iconError-light">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/X.svg"
                                    )}
                                  />
                                </span>
                              </div>
                            </Col>
                          )}
                          <Col sm={1}>
                            {fieldsCP.length - 1 === idx && (
                              <Button
                                variant="outline-primary"
                                onClick={(e) => handleAdd()}
                                className="mt-4 "
                              >
                                Add
                              </Button>
                            )}
                          </Col>
                        </Row>
                      </div>
                    );
                  })}
                </Col>

                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    label="Email"
                    inputProps={{ maxLength: 128 }}
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="email"
                    onChange={handleChange}
                    value={formValues.email.value}
                  />
                </Col>
              </Row>

              <Row className="mt-6 justify-content-end">
                <Button variant="primary" onClick={handleSave}>
                  Save
                </Button>
              </Row>
              <hr />

              {/* Office */}
              <div>
                <h5 className="font-weight-boldest">Office</h5>

                <BootstrapTable
                  wrapperClasses="table-responsive"
                  classes="table table-head-custom table-vertical-center overflow-hidden rounded table-container"
                  bootstrap4
                  
                  keyField="office_id"
                  data={listOffice}
                  columns={columns}
                  // sort={{ dataField: sortField, order: sortOrder }}
                  hover
                  striped
                  headerClasses="header-class"
                />

                <Row className="mt-6 justify-content-end">
                  <Button variant="outline-primary" onClick={handleShow}>
                    Add Office
                  </Button>
                </Row>
              </div>
            </CardBody>
          </ThemeProvider>
        </Card>

        <ModalOfficeSelect
          isOpen={show}
          handleClose={handleClose}
          handleShow={handleShow}
          setShow={setShow}
          setFields={setFields}
          fields={fields}
          id={id}
        />
      </>
    )
  );
};
